import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from '@ontruck/orc';

const WithValue = ({
  valueLabel,
  value,
  editLabel,
  editIcon,
  editButtonAction,
  isConfigRecurringPage,
  disableEdit = false,
}) => (
  <div className="info-wrapper" data-testid="with-value">
    <div>
      <p className="label">{valueLabel}</p>
      <p className="reference">{value}</p>
    </div>

    {!isConfigRecurringPage && !disableEdit && (
      <button className="edit" type="button" onClick={editButtonAction}>
        <Icon
          className="icon"
          glyph={editIcon}
          size="12px"
          color="primary500"
        />
        <span className="">{editLabel}</span>
      </button>
    )}
  </div>
);

WithValue.propTypes = {
  valueLabel: PropTypes.string,
  value: PropTypes.string,
  editLabel: PropTypes.string,
  editIcon: PropTypes.string,
  editButtonAction: PropTypes.func,
};

WithValue.defaultProps = {
  valueLabel: '',
  value: '',
  editLabel: '',
  editIcon: '',
  editButtonAction: () => ({}),
};

export default WithValue;
